import React, { useState } from 'react';
import { UserInfo } from '../types';
import { saveAuth, apiCall } from '../auth';
import { Lang, LANGUAGES, loadLang, saveLang, t } from '../i18n';

interface Props {
  onLogin:     (user: UserInfo, token: string) => void;
  lang:        Lang;
  onLangChange: (lang: Lang) => void;
}

const LoginScreen: React.FC<Props> = ({ onLogin, lang, onLangChange }) => {
  const [login,    setLogin]    = useState('');
  const [password, setPassword] = useState('');
  const [error,    setError]    = useState('');
  const [loading,  setLoading]  = useState(false);

  const tr = t(lang);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!login.trim() || !password) {
      setError(tr.loginErrEmpty);
      return;
    }
    setLoading(true);
    setError('');
    try {
      const data = await apiCall<{ token: string; user: UserInfo }>(
        'POST', '/api/auth/login', null, { login: login.trim(), password },
      );
      saveAuth(data.token, data.user);
      onLogin(data.user, data.token);
    } catch (err: any) {
      setError(err.message ?? tr.loginErrServer);
    } finally {
      setLoading(false);
    }
  };

  const handleLang = (code: Lang) => {
    saveLang(code);
    onLangChange(code);
  };

  return (
    <div className="login-screen">
      <div className="login-card">

        <div className="login-logo">
          <img
            src={process.env.PUBLIC_URL + '/logo.png'}
            alt="PDD"
            style={{ width: 180, height: 'auto', background: '#ffffff', borderRadius: 4, display: 'block', margin: '0 auto' }}
          />
        </div>
        <div className="login-subtitle">{tr.loginSubtitle}</div>

        <form onSubmit={handleSubmit} className="login-form">
          <label className="login-label">
            {tr.loginUsername}
            <input
              type="text"
              className="login-input"
              value={login}
              onChange={e => setLogin(e.target.value)}
              autoFocus
              autoComplete="username"
              disabled={loading}
            />
          </label>

          <label className="login-label">
            {tr.loginPassword}
            <input
              type="password"
              className="login-input"
              value={password}
              onChange={e => setPassword(e.target.value)}
              autoComplete="current-password"
              disabled={loading}
            />
          </label>

          {error && <div className="login-error">{error}</div>}

          <button type="submit" className="login-btn" disabled={loading}>
            {loading ? tr.loginLoading : tr.loginBtn}
          </button>
        </form>

        {/* Przełącznik języka – poniżej przycisku logowania */}
        <div className="lang-switcher">
          {LANGUAGES.map(l => (
            <button
              key={l.code}
              className={`lang-btn${lang === l.code ? ' lang-btn-active' : ''}`}
              onClick={() => handleLang(l.code)}
            >
              {l.label}
            </button>
          ))}
        </div>

        <div className="login-version">ver260403.001</div>
      </div>
    </div>
  );
};

export default LoginScreen;
